<div class="container" fxLayout="column">
  <div *ngIf="tabs" fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="4px">
    <div *ngFor="let tab of tabs" (click)="click(tab)" class="title relative">
      {{ tab.title }}
      <div *ngIf="clickedTab === tab" class="subtab-container">
        <div
          *ngFor="let subTab of tab.subTabs"
          (click)="clickSubTab($event, subTab)"
          class="title sub-title"
        >
          {{ subTab.title }}
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="tabs && selectedTab" class="code-container">
    <nw-code [data]="selectedData" [height]="height"> </nw-code>
  </div>
  <div *ngIf="!selectedTab && !tabs" fxLayout="column">
    <div class="content" [ngStyle]="style">
      <div *ngIf="text">{{ text }}</div>
      <ng-container *ngIf="!text">
        <ng-content></ng-content>
      </ng-container>
    </div>
  </div>
</div>
